import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./ServicesSection.css";
import Button from "../Button/Button";
import Tag from "../Tag/Tag";
import { GoFileMedia } from "react-icons/go";
import { FaChartPie } from "react-icons/fa6";
import { FaCamera, FaGlobe, FaGoogle, FaGlasses } from "react-icons/fa";
import { Link } from "react-router-dom";


const ServicesSection = () => {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);


  const servicesData = [
    {
      title: "Social Media Page Management",
      msg: "We manage your Instagram and Facebook like pros—with strategic content, scheduled posts, timely responses, and weekly insights. We keep your page active, consistent, and audience-focused.",
      icon: <GoFileMedia />
    },
    {
      title: "Sponsored Ads on Meta, TikTok, Google & Snapchat",
      msg: "We run conversion-focused ads designed to get you leads, customers, and real business growth. Our ad campaigns are fully tailored to your goals—whether it's traffic, sales, followers, or visibility.",
      icon: <FaChartPie />
    },
    {
      title: "Content Creation that Converts",
      msg: "We design scroll-stopping graphics, engaging videos, motion graphics, and even voiceovers that bring your brand to life and attract the right audience.",
      icon: <FaCamera />
    },
    {
      title: "Website Design & Development",
      msg: "Your website is your digital home—let's make it beautiful, functional, and built to convert. Whether it's a corporate site or full e-commerce store, we deliver clean, fast, and mobile-ready platforms.",
      icon: <FaGlobe />
    },
    {
      title: "Meta Verification",
      msg: "Want the blue check? We help eligible businesses and creators get Meta Verified. It boosts trust, SEO visibility, and audience reach.",
      icon: <GoFileMedia />
    },
    {
      title: "Google Business Setup",
      msg: "We help clients show up in Google searches and maps with full business listings, reviews, and local optimization.",
      icon: <FaGoogle />
    },
    {
      title: "Tech Talent Hiring Platform",
      msg: "Need help building your team? Our platform allows you to hire vetted digital talents—content creators, web developers, ad specialists, graphic designers, and more.",
      icon: <FaGlasses />
    },
  ]

  return (
    <section className="ServicesSection">
      <div className="ServicesSection-container">
        <Tag 
          title="Our Services"
          variant="primary"
        />
        
        <h2 className="ServicesSection-title header-1" data-aos="fade-up">Our Agency's Unique Services</h2>
        <p className="ServicesSection-subtitle" data-aos="fade-up">
          Professional project management to ensure timely delivery and budget compliance for your projects
        </p>



        <div className="ServicesSection-grid">
          {
            servicesData.map((service, serveId) => {
              return (
                <div className={`ServiceCard`} data-aos="fade-up" key={serveId}>
                  <div className="ServiceCard-icon"> {service.icon} </div>
                  <h3 className="ServiceCard-title"> {service.title} </h3>
                  <p className="ServiceCard-description"> {service.msg} </p>
                  <Link to="/services" className="ServiceCard-link">Learn More →</Link>
                </div>
              )
            })
          }
        </div>



        <div className="ServicesSection-more" data-aos="fade-up">
          <Button variant="primary" text="More Services" url="/services" />  
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
